import {
  MetabaseLogo,
  SigmaLogo,
  TableauLogo,
} from '~/components-v2/compete-comparison-card'

export const compareItems = [
  { logo: <SigmaLogo />, link: '/omni-vs-sigma' },
  { logo: <MetabaseLogo />, link: '/omni-vs-metabase' },
  { logo: <TableauLogo />, link: '/omni-vs-tableau' },
]
